<template lang="pug">
header
  .mask(v-if="mask")
    b-spinner.preloader
  b-navbar.default-layout-navbar.col-12.p-0.d-flex.flex-row(ref="navbar",v-if="currentUser")
    b-navbar-brand.text-center.navbar-brand-wrapper.d-flex.align-items-center.justify-content-center(href="/")
      //-img.brand-logo-mini(src="../../assets/images/logo-mini.svg",alt="logo",:title="app.name")

    b-navbar-nav.navbar-nav-right.ml-auto
      b-nav-item-dropdown(right,size="sm")
        template(slot="button-content")
          //-i.fas.fa-user-circle
          span.ml-2 {{ currentUser.Company && currentUser.Company.name ? currentUser.Company.name : '(no company)' }}
          span.ml-2 /
          span.ml-2 {{ currentUser.name ? currentUser.name : '(no name)' }}
        b-dropdown-item(@click="handleLink(`/${$route.params.directory}/setup/profile`)")
          i.fas.fa-user.mr-2
          span マイプロフィール
        b-dropdown-item(@click="doResetPassword()")
          i.icon.fas.fa-key.mr-2.ml-3
          span パスワードのリセット
        b-dropdown-divider
        template(v-if="currentUser && currentUser.otherCompanies && currentUser.otherCompanies.length > 0")
          b-dropdown-item(v-b-modal.modal-changeCompany)
            i.icon.fas.fa-building.mr-2
            span 会社の切り替え
          b-dropdown-divider
        b-dropdown-item(@click="doLogout()")
          i.fas.fa-sign-out-alt.mr-2
          span ログアウト
    .popups(v-if="messages.length > 0")
      b-alert(v-for="(message, index) in messages",:key="index",:show="dismissCount",dismissible,@dissmissed="dismissCount = 0",@dismiss-count-down="dismissChanged",:data-index="index") {{ message }}

  b-modal#modal-changeCompany(hide-header)
    b-list-group(v-if="currentUser && currentUser.otherCompanies")
      b-list-group-item(button,v-for="(otherCompany, index) in currentUser.otherCompanies",:key="index",@click="doChangeCompany(otherCompany)") {{ otherCompany && otherCompany.name ? otherCompany.name : '?' }}
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="secondary",@click="$bvModal.hide('modal-changeCompany')") キャンセル
</template>

<script>
import { getData, postData } from '../../utils/api'

import { clone } from '../../utils/libs'

import dayjs from 'dayjs'

const otherUrl = `${process.env.VUE_APP_APP_PROTOCOL}://${process.env.VUE_APP_APP_DOMAIN}/*/`

export default {
  data () {
    return {
      app: {
        name: process.env.VUE_APP_NAME
      },
      currentUser: null,
      messages: [],
      dismissCount: 0,
      mask: false
    }
  },
  watch: {
    '$parent.mask' (val) {
      this.mask = this.$parent.mask
    }
  },
  async created () {
    this.$store.commit('setDirectory', this.$route.params.directory)
    this.$root.directory = this.$route.params.directory

    if (!this.$auth.isAuthenticated) {
      this.login()
    }

    let accessToken
    if (this.$store.state.accessToken && dayjs(this.$store.state.expireIn).toDate() > new Date()) {
      accessToken = this.$store.state.accessToken
    } else {
      accessToken = await this.$auth.getTokenSilently()
      this.$store.commit('setAccessToken', accessToken)
    }
    if (this.$auth.isAuthenticated && accessToken) {
      this.loadData()
    }
  },

  methods: {
    login () {
      this.$auth.loginWithRedirect()
    },
    async loadData () {
      await getData(`/myprofile/`).then((datum) => {
        if (datum) {
          this.$set(this, 'currentUser', clone(datum))
          this.$parent.currentUser = clone(datum)
          this.$root.currentUser = clone(datum)
        } else {
          this.$bvModal.msgBoxOk('登録情報の取得に失敗しました').then(async () => {
            await this.$store.commit('clearAccessToken')
            this.$auth.logout()
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      if (this.$parent.prepareData) {
        await this.$parent.prepareData()
      } else if (this.$parent.reloadData) {
        await this.$parent.reloadData()
      } else if (this.$parent.loadData) {
        await this.$parent.loadData()
      } else {
        this.checkCondition()
      }

      if (this.$route.query && this.$route.query.f && this.$route.query.f === 'verify') {
        // verify email
        const isOtherEmail = this.currentUser.otherEmails &&
        this.currentUser.otherEmails.find((otherEmail) => {
          return otherEmail.email === this.$route.query.email
        })
        if (isOtherEmail && !isOtherEmail.state) {
          try {
            await postData(`/myprofile/verified/`, {
              email: this.$route.query.email
            }).then((json) => {
              if (json && json.email) {
                this.msgBoxError(`予備のメールアドレスが有効化されました`, async () => {
                  this.handleLink(`/${this.$route.params.directory}/setup/profile`)
                })
              } else {
                this.$router.replace(`/${this.$route.params.directory}/`)
              }
            }).catch((err) => {
              console.log(err)
            })
          } catch (e) {
            console.log(e)
          }
        } else {
          this.$router.replace(`/${this.$route.params.directory}/`)
        }
      }

      this.$forceUpdate()
    },
    reload () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    async checkCondition () {
      const message = await this.CheckCondition()
      if (message) {
        this.messages.push(message)
        this.dismissCount = 30
      }
    },
    dismissChanged (dismissCount) {
      this.dismissCount = dismissCount
      if (this.dismissCount === 0) {
        this.messages = []
      }
    },
    doChangeCompany (company) {
      this.msgBoxConfirm('会社を切り替えますか？', () => {
        window.location.href = otherUrl.replace('*', company.directory)
      })
    }
  }
}
</script>

<style scoped lang="stylus">
header
  position relative
  .mask
    position absolute
    width 100vw
    height 100vh
    top 0
    left 0
    background-color rgba(255, 255, 255, 0.5)
    z-index 999999
    .preloader
      position absolute
      top 50%
      left 50%
      margin-left -16px
      margin-top -16px
  .main
    .navbar
      //pointer-events none
      //cursor default
  .popups
    position absolute
    z-index 100
    top 0
    left 0
    padding-left 5rem
    margin-top 0.3rem
    margin-left 0.3rem
</style>

<style lang="stylus">
header
  .dropdown-menu
    z-index 10000

.main.narrow
  .popups
    padding-left 15rem
</style>
